import React, { useState, useEffect } from "react";
import CurrencyFormat from "react-currency-format";

const InvoiceTableBody = ({
  setShowInvoiceDetailModal,
  setInvoiceDetail,
  tableData,
  columns,
}) => {
  const updateInvoiceDetail = (invoice) => {
    setShowInvoiceDetailModal(true);
    setInvoiceDetail(invoice);
  };

  return (
    <>
        <tbody>
          {tableData.map((data) => {
            return (
              <tr key={data.id} onClick={() => updateInvoiceDetail(data)}>
                {columns.map(({ accessor }) => {
                  const tData = data[field] ? data[field] : "——";
                  if (field == "nairaBalance") {
                    return (
                      <td className="py-4 px-6 text-sm font-medium text-black whitespace-nowrap dark:text-black">
                        {data.currencyCode != "USD" ? (
                          <>
                            <span className="font-semibold text-sm">
                              &#8358;
                            </span>{" "}
                            <CurrencyFormat
                              value={parseFloat(data.balance)}
                              displayType={"text"}
                              thousandSeparator={true}
                              decimalScale={2}
                            />
                          </>
                        ) : null}
                      </td>
                    );
                  }

                  if (field == "dollarBalance") {
                    return (
                      <td className="py-4 px-6 text-sm font-medium text-black whitespace-nowrap dark:text-black">
                        {data.currencyCode != "NGN" ? (
                          <>
                            <span className="font-semibold text-sm">&#36;</span>{" "}
                            <CurrencyFormat
                              value={parseFloat(data.balance)}
                              displayType={"text"}
                              thousandSeparator={true}
                              decimalScale={2}
                            />
                          </>
                        ) : null}
                      </td>
                    );
                  }

                  if (field == "balance") {
                    return (
                      <td className="py-4 px-6 text-sm font-medium text-black whitespace-nowrap dark:text-black">
                        {data.currencyCode != "USD" ? (
                          <span className="font-semibold text-sm text-black">
                            &#8358;
                          </span>
                        ) : (
                          <span className="font-semibold text-sm text-black">
                            &#36;
                          </span>
                        )}{" "}
                        <CurrencyFormat
                          value={parseFloat(data.balance)}
                          displayType={"text"}
                          thousandSeparator={true}
                          decimalScale={2}
                        />
                      </td>
                    );
                  }
                  return <td key={accessor}>{tData}</td>;
                })}
              </tr>
            );
          })}
        </tbody>
    </>
  );
};

export default InvoiceTableBody;
